import React, { useEffect, useState } from 'react'
import BottomNav from './components/BottomNav';
import logo from "./assets/images/cc-logo.png";


export default function PricesPage() {


  //https://anyapi.io/api/v1/exchange/rates?apiKey=dfkdqq6hcpv993qnfibgc60sfo3mrpgbl51r39jamtq78b94agdo

  const backend = "https://cc-node.onrender.com/getRates"

  const [exr, setExr] = useState({"lastUpdate":1683158400,"base":"EUR","rates":{"EUR":1,"USD":-1,"JPY":148.92,"BGN":1.9558,"CZK":23.46,"DKK":7.4503,"GBP":0.88015,"HUF":373.94,"PLN":4.5905,"RON":4.9295,"SEK":11.341,"CHF":0.9802,"ISK":150.1,"NOK":11.8282,"TRY":21.5825,"AUD":1.6585,"BRL":5.5194,"CAD":1.5072,"CNY":7.6538,"HKD":8.6909,"IDR":16263.59,"ILS":4.0268,"INR":90.5495,"KRW":1465.69,"MXN":19.8208,"MYR":4.9313,"NZD":1.7668,"PHP":61.286,"SGD":1.4695,"THB":37.43,"ZAR":20.1357}});

  useEffect( () => {
     fetch(backend, 
     {method: "GET",
    
    headers: {
      
      'Content-Type': 'application/json'
       
    }
  })
    .then(data => data.json())
    .then(json => setExr(json))
    .then(json => console.log(json))
  }, [])

  return (
    <div className="assets-panel bg-[#242626] min-h-[100vh] ">
        <div className="containerx text-white">
        <img src={logo} className="py-7 w-48" alt="" />
          <p className="text-[#6c6c6c] mb-2">current currency prices</p>

          <div className="rates flex flex-col gap-1">

          <div className="py-4 border-b border-white/10 flex items-center justify-between">
            <h3 className='text-xl font-bold'>USD</h3>
            <p> {exr.rates.USD} </p>

          </div>

          <div className="py-4 border-b border-white/10 flex items-center justify-between">
            <h3 className='text-xl font-bold'>GBP</h3>
            <p> {exr.rates.GBP} </p>

          </div>

          <div className="py-4 border-b border-white/10 flex items-center justify-between">
            <h3 className='text-xl font-bold'>CZK</h3>
            <p> {exr.rates.CZK} </p>

          </div>

          <div className="py-4 border-b border-white/10 flex items-center justify-between">
            <h3 className='text-xl font-bold'>INR</h3>
            <p> {exr.rates.INR} </p>

          </div>

          </div>
        


        </div>
        <BottomNav />
      </div>
  )
}
